var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.context.request.feature_flags.ff_redesign_rating
    ? _c(
        "div",
        { attrs: { "data-qa": "rating_card" } },
        [
          _c(_setup.RatingRow, {
            attrs: {
              pill: "",
              solidity: _vm.stars,
              "reviews-count": _vm.allrates,
              "reviews-href": _setup.reviewsHref,
            },
          }),
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass:
            "rounded-20 border-sm pa-4 primary--text link-decoration-underline cursor-pointer",
          attrs: { "data-qa": "rating_card" },
          on: { click: _setup.handleClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-center gc-2",
              class: { "justify-space-between": _setup.isMobile },
            },
            [
              _c(_setup.StarsRate, {
                attrs: { "data-qa": "rating_stars", solidity: _vm.stars },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-body-1 text-no-wrap primary--text" },
                [
                  _c("span", { attrs: { "data-qa": "rating_count" } }, [
                    _vm._v(_vm._s(_vm.allrates)),
                  ]),
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.tStatic(_setup.rateText)) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }